import React from "react";

interface IProps extends React.CSSProperties {
    children?: React.ReactNode;
    ref?: React.RefObject<HTMLDivElement>;
    onClick?: () => void;
    className?: string;
    sx?: React.CSSProperties;
}

const Box: React.FC<IProps> = ({
    children,
    onClick,
    className,
    ref,
    sx,
    ...restProps
}) => {
    return (
        <div
            onClick={onClick}
            style={{ ...restProps, ...sx }}
            className={className}
            ref={ref}
        >
            {children}
        </div>
    );
};

export default React.memo(Box);